
import { useQuery } from "@tanstack/react-query";
import { GETMarketplaceItemDetail } from "../requests";

export const GET_ITEM_DETAIL_QUERY_KEY = (itemId: number) => ["itemDetail", itemId];

export const useMarketplaceItemDetail = (itemId: number) => {
  return useQuery({
    queryKey: GET_ITEM_DETAIL_QUERY_KEY(itemId),
    queryFn: () => GETMarketplaceItemDetail(itemId),
    enabled: !!itemId, 
  });
};